import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Environment } from '../../../environments/types/environment.type';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly environment: Environment = environment;

  getEnv<T extends keyof Environment>(key: T): Environment[T] {
    return this.environment[key];
  }
}
